import { Component } from '@angular/core';
import { SpinnerService } from '@shared/services/spinner.service';
import { RegistrationService } from 'app/features/register/services/registration.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent {
  profileInfo: any;

  constructor(
    private registrationService: RegistrationService,
    private spinnerService: SpinnerService,
  ) {
    this.profileInfo = this.registrationService.getProfileInfo();
    this.spinnerService.stop();
  }
}
